import { Link } from 'react-router-dom';
import type { Resource } from '@/mocks/resources';

interface ResourceCardProps {
  resource: Resource;
}

export default function ResourceCard({ resource }: ResourceCardProps) {
  return (
    <Link
      to={`/article/${resource.id}`}
      className="group block bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer"
    >
      <div className="relative w-full aspect-[4/3] overflow-hidden">
        <img
          src={resource.coverImage}
          alt={resource.title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          title={resource.title}
        />
        <div className="absolute top-3 left-3">
          <span className="px-2.5 py-1 bg-background-50/90 backdrop-blur-sm text-xs font-medium text-foreground-700 rounded-full">
            {resource.category}
          </span>
        </div>
        {resource.featured && (
          <div className="absolute top-3 right-3">
            <span className="px-2.5 py-1 bg-accent-500 text-background-50 text-xs font-bold rounded-full">
              精选
            </span>
          </div>
        )}
      </div>
      <div className="p-4">
        <h3 className="font-heading text-base font-bold text-foreground-950 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors duration-200">
          {resource.title}
        </h3>
        <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2 mb-3">
          {resource.description}
        </p>
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2 text-xs text-foreground-400">
            <span className="flex items-center gap-1">
              <i className="ri-download-line"></i>
              {formatCount(resource.downloadCount)}
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-star-fill text-primary-400"></i>
              {resource.rating}
            </span>
          </div>
          <span className="text-xs text-foreground-300">{resource.date}</span>
        </div>
      </div>
    </Link>
  );
}

function formatCount(count: number): string {
  if (count >= 10000) return `${(count / 10000).toFixed(1)}万`;
  if (count >= 1000) return `${(count / 1000).toFixed(1)}k`;
  return String(count);
}